import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { Button, IconButton } from '@treams/treams-ui';
import { AddIcon, DeleteIcon, ReorderIcon } from '@treams/treams-icons';

import * as graphql from 'generated/graphql';

import { Library } from '@treams/treams-ui';
import FeedbackQuestionCard from './FeedbackQuestionCard';

const Ord = styled(Flex)`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	align-items: center;
	justify-content: center;
`;

export default function FeedbackTemplateQuestion(props: {
	index: number;
	question: graphql.FeedbackQuestion;
	loading?: boolean;
	onDelete: () => Promise<void>;
}) {
	const { t } = useTranslation();

	return (
		<Flex alignItems="center">
			<motion.div layoutId={`ord:${props.index}`} transition={{ duration: 0.2, ease: 'circOut' }}>
				<Ord>{props.index + 1}</Ord>
			</motion.div>
			<Box flexGrow={1} flexShrink={1} ml={2}>
				<Library.Item.Draggable
					handleIcon={<ReorderIcon />}
					item={props.question}
					loading={props.loading}
					buttons={[
						// This one probably has the wrong type in Library.Item.Draggable
						// eslint-disable-next-line react/jsx-key
						<Button
							type="destructive"
							title={t('settings.feedbackLibrary.template.questions.remove.button')}
							ml={2}
							small
							icon={<DeleteIcon />}
							onClick={props.onDelete}
						/>,
					]}
					renderCard={(props) => <FeedbackQuestionCard {...props} />}
					readOnly
				/>
			</Box>
		</Flex>
	);
}

function FeedbackTemplateQuestionSkeleton() {
	return (
		<Flex alignItems="center">
			<Box width={32} />
			<Box flexGrow={1} flexShrink={1} ml={2}>
				<Library.Item.Skeleton />
			</Box>
		</Flex>
	);
}

FeedbackTemplateQuestion.Skeleton = FeedbackTemplateQuestionSkeleton;

const PlaceholderContainer = styled(Flex)`
	border: 1px dashed ${(props) => props.theme.colors.lightBlueDark};
	min-height: 94px;
	border-radius: 5px;
	cursor: pointer;
	transition:
		0.2s ease-in-out border-color,
		0.2s ease-in-out background-color;

	&:hover {
		border-color: transparent;
		background: ${(props) => props.theme.colors.lightBlueLight};

		&:active {
			background: ${(props) => props.theme.colors.lightBlue};
		}
	}
`;

function FeedbackTemplateQuestionPlaceholder() {
	return (
		<PlaceholderContainer alignItems="center" justifyContent="center" ml={80}>
			<IconButton type="secondary" icon={<AddIcon />} />
		</PlaceholderContainer>
	);
}

FeedbackTemplateQuestion.Placeholder = FeedbackTemplateQuestionPlaceholder;
